import { useMemo } from 'react';
import { ThemeProvider, createTheme } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { QueryClient, QueryClientProvider } from 'react-query';
import { RouterProvider } from 'react-router-dom';
import router from 'routes/router';
import { darkMode, lightMode } from 'utils/customTheme';
import Root from './websiteinfo/Root';
import { AppInfoProvider } from 'context/AppInfoContext';
import {
  ThemeModeProvider,
  useThemeMode,
} from 'context/ThemeModeContext';
import { FacebookProvider } from 'react-facebook';

// Kun/Tun rejimi almashganda MUI mavzusi qayta quriladi
function AppThemeProvider({ children }) {
  const { isDark } = useThemeMode();
  const theme = useMemo(
    () => createTheme(isDark ? darkMode : lightMode),
    [isDark],
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  const snackBarOptions = {
    iconVariant: {
      error: (
        <i className='bi bi-x-octagon' style={{ marginInlineEnd: '8px' }} />
      ),
    },
    maxSnack: 3,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
  };

  return (
    <ThemeModeProvider>
      <AppThemeProvider>
        <QueryClientProvider client={queryClient}>
          <FacebookProvider appId='676597308246606'>
            <SnackbarProvider {...snackBarOptions}>
              <AppInfoProvider>
                <Root>
                  <RouterProvider router={router} />
                </Root>
              </AppInfoProvider>
            </SnackbarProvider>
          </FacebookProvider>
        </QueryClientProvider>
      </AppThemeProvider>
    </ThemeModeProvider>
  );
}

export default App;
